import React from "react";

const ScrollbarWrapper = React.forwardRef(function ScrollbarWrapper(
  { children, className = "", ...rest },
  ref
) {
  return (
    <div
      ref={ref}
      className={`
        scrollbar-thin
        scrollbar-thumb-[#A0AEC0] dark:scrollbar-thumb-[#3b5bdb]
        scrollbar-track-gray-100 dark:scrollbar-track-[#1A1C23]
        scrollbar-thumb-rounded-full scrollbar-track-rounded-full
        ${className}
      `}
      {...rest}
    >
      {children}
    </div>
  );
});

export default ScrollbarWrapper;